var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSummaryEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.70938 2.58105H2.49097C2.09554 2.58105 1.71631 2.73814 1.4367 3.01775C1.15708 3.29736 1 3.6766 1 4.07203V14.5088C1 14.9043 1.15708 15.2835 1.4367 15.5631C1.71631 15.8427 2.09554 15.9998 2.49097 15.9998H12.9278C13.3232 15.9998 13.7024 15.8427 13.9821 15.5631C14.2617 15.2835 14.4188 14.9043 14.4188 14.5088V9.29043",
    stroke: "#183171",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3008 1.46319C13.5973 1.16661 13.9996 1 14.419 1C14.8384 1 15.2406 1.16661 15.5372 1.46319C15.8338 1.75976 16.0004 2.162 16.0004 2.58142C16.0004 3.00083 15.8338 3.40307 15.5372 3.69964L8.45509 10.7818L5.47314 11.5273L6.21863 8.54531L13.3008 1.46319Z",
    stroke: "#183171",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummaryEdit);
export default __webpack_public_path__ + "static/media/summaryEdit.5daff0dcf904090a1b974052c0a1b895.svg";
export { ForwardRef as ReactComponent };